export enum FileType {
    PDF = 'pdf',
    XLS = 'xls',
    XLSX = 'xlsx',
    CSV = 'csv',
    PNG = 'png',
    JPEG = 'jpeg',
    JPG = 'jpg',
}
